export default __webpack_public_path__ + "static/media/logo.ea029f8e.svg";